module.exports = __webpack_public_path__ + "static/media/search.baf15157.svg";